module.exports = __webpack_public_path__ + "img/profile_box_licenses.2f8436ab.svg";